import { useEffect } from "react";
import { EMPTY_EDITOR_CONTENT, type TextEditorRef } from "../TextEditor";

type UseSetEditorContentProps = {
  ref: TextEditorRef | null;
  note: string | null | undefined;
};

export const useSetEditorContent = ({
  ref,
  note,
}: UseSetEditorContentProps) => {
  useEffect(() => {
    if (ref?.getContent() === note) return;
    if (!ref || !note?.length) {
      ref?.setContent(EMPTY_EDITOR_CONTENT);
      return;
    }

    ref.setContent(note);
  }, [ref, note]);
};
